import { Button, Grid } from '@material-ui/core';
import Step from "@material-ui/core/Step";
import StepLabel from "@material-ui/core/StepLabel";
import Stepper from "@material-ui/core/Stepper";
import { makeStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import ArrowBackIosIcon from '@material-ui/icons/ArrowBackIos';
import React, { useEffect, useState } from 'react';
import { useHistory, useLocation } from "react-router-dom";
import http from "../services/httpService";
import { getDate, getDateTime ,searchFilter,handleSort } from "../utils/varialbles";
import IconButton from '@material-ui/core/IconButton';
import staticFiles from '../services/staticApi';
import AccountCircleOutlinedIcon from '@material-ui/icons/AccountCircleOutlined';
import FiberManualRecordIcon from '@mui/icons-material/FiberManualRecord';
const useStyles = makeStyles({
    root: {
        width: '100%',
        backgroundColor: "#F5F7FA",
        padding: "7px"
    },
    circle: {

        borderRadius: "100%",
        background: "#3f51b5",
        color: "#fff",
    }
});
function MyPerformanceOverview(params) {
    let profile = params.profile;
    let history = useHistory();
    const classes = useStyles();
    const [showWindow, setShowWindow] = useState(true);
    const [overview, setOverview] = useState({});
    const [performance,setPerfromance] = useState({});
    const [activityDetails, setActivityDetails] = useState([]);
    useEffect(() => {

        http.get("/profile_performance").then(res => {
            if (res && res.data && res.data["Profile details"] && Array.isArray(res.data["Profile details"]) && res.data["Profile details"].length > 0) {
                let details = res.data["Profile details"][0];
                if (details.languages && Array.isArray(details.languages)) {
                    details.languages = details.languages.join(",");
                }
                setOverview(details)
            }
            if (res && res.data && res.data["Performance"] && Array.isArray(res.data["Performance"]) && res.data["Performance"].length > 0) {
                let perfromanceDetails = res.data["Performance"][0];
                setPerfromance(perfromanceDetails)
            }
            if (res && res.data && res.data.Activity_Log && Array.isArray(res.data.Activity_Log) && res.data.Activity_Log.length > 0) {
                setActivityDetails(res.data.Activity_Log);
            }
        }).catch(err => {

        })
    }, [])

    return (<Grid container style={showWindow ? { display: "block" } : { display: "none" }} >


        <Grid container style={{ marginTop: "10px" }} className={'prospectgrids'}>
            <Grid item xs={12} sm={12} md={4} style={{ marginTop: 23 }}>
                <Button variant="outlined" color="default" startIcon={<ArrowBackIosIcon />} onClick={history.goBack}>Back</Button>
            </Grid>
            <Grid item xs={12} sm={12} md={6} style={{ marginTop: 30 }}>
                <Typography  color="textPrimary" variant="h5" >My Performance</Typography>
            </Grid>
        </Grid>
        <Grid container style={{ marginTop: "70px" }} >
            <Grid item xs={12} sm={12} md={2} >
                <IconButton className={'profileImage'}>{profile && profile.profile_pic && profile.profile_pic !== "" ? <img src={staticFiles + profile.profile_pic} style={{
                    width: 150,
                    height: 150, borderRadius: "50%"
                }}></img> : <AccountCircleOutlinedIcon style={{
                    width: 150,
                    height: 150,
                    color: "gray"
                }} />}</IconButton>
            </Grid>
            <Grid item xs={12} sm={12} md={10} className={'prospectgrids'}>
                <Grid container >
                    <Grid item xs={12} sm={6} md={3} >
                        <Typography  variant="body1">Name</Typography>
                        <Typography  variant="h6">{overview.empfname + " " + overview.emplname}</Typography>

                    </Grid>
                    <Grid item xs={12} sm={6} md={3}>
                        <Typography  variant="body1">Email ID</Typography>
                        <Typography  variant="h6">{overview.empemail}</Typography>

                    </Grid>
                    <Grid item xs={12} sm={6} md={3}>
                        <Typography  variant="body1">Joining Date</Typography>
                        <Typography  variant="h6">{getDate(overview.empcreateddt)}</Typography>

                    </Grid>
                    <Grid item xs={12} sm={6} md={3}>
                        <Typography  variant="body1">Role</Typography>
                        <Typography  variant="h6">{overview.empdept}</Typography>
                    </Grid>
                    <Grid item xs={12} sm={6} md={3} style={{ marginTop: "30px" }}>
                        <Typography  variant="body1">My Languages</Typography>
                        <Typography  variant="h6">{overview.languages}</Typography>
                    </Grid>
                </Grid>
            </Grid>
        </Grid>
        <Grid item xs={12} sm={12} md={12} style={{ marginTop: 30 }} className={'prospectgrids'}>
            <Typography  color="textPrimary" variant="h5" >Performance</Typography>
        </Grid>
        <Grid container style={{ marginTop: 10 }} className={'prospectgrids'}>
            <Grid item xs={12} sm={6} md={3} >
                <Typography  variant="body1">Number of days since joining</Typography>
                <Typography  variant="h6">{performance.days_sincejoin}</Typography>

            </Grid>
            <Grid item xs={12} sm={6} md={3}>
                <Typography  variant="body1">Number of prospects assigned</Typography>
                <Typography  variant="h6">{performance.prospect_count}</Typography>

            </Grid>
            <Grid item xs={12} sm={6} md={3}>
                <Typography  variant="body1">Number of investors assigned</Typography>
                <Typography  variant="h6">{performance.investors_count}</Typography>

            </Grid>
            <Grid item xs={12} sm={6} md={3}>
                <Typography  variant="body1">Average Response Time(TAT)</Typography>
                <Typography  variant="h6">{performance.empdept}</Typography>
            </Grid>
        </Grid>
        <Grid container style={{ marginTop: 10 }} className={'prospectgrids'}>
            <Grid item xs={12} sm={6} md={3} >
                <Typography  variant="body1">Renewal rate of investors assigned</Typography>
                <Typography  variant="h6">{performance.Renewal_rate&&(!isNaN(performance.Renewal_rate))?performance.Renewal_rate.toFixed(2)+"%":performance.Renewal_rate}</Typography>

            </Grid>
            <Grid item xs={12} sm={6} md={3}>
                <Typography  variant="body1">Prospect to Investor conversion rate</Typography>
                <Typography  variant="h6">{performance.ptoi_conversionrate&&(!isNaN(performance.ptoi_conversionrate))?performance.ptoi_conversionrate.toFixed(2)+"%":performance.ptoi_conversionrate}</Typography>

            </Grid>
            
        </Grid>
        <Grid item xs={12} sm={12} md={12} style={{ marginTop: 30 }} className={'prospectgrids'}>
            <Typography  color="textPrimary" variant="h5" >Activity History</Typography>
        </Grid>
        <Grid container style={{ marginTop: 10 }} className={'prospectgrids'}>
            <Grid item xs={12} sm={6} md={3} >
                <Typography  variant="body1">Last Login</Typography>
                <Typography  variant="h6">{getDateTime(overview.last_login)}</Typography>

            </Grid>
            <Grid item xs={12} sm={6} md={3}>
                <Typography  variant="body1">Last Logout</Typography>
                <Typography  variant="h6">{getDateTime(overview.last_logout)}</Typography>

            </Grid>
            
        </Grid>
        <Grid container style={{ marginTop: "20px" }}>
            <Grid item xs={12} sm={12} md={12} >

                <Stepper

                    orientation="vertical"
                    nonLinear
                    defaultColor="primary"
                >
                    {activityDetails.map((label, index) => {
                        return (
                            <Step key={label.id} active>
                                <StepLabel icon={<FiberManualRecordIcon style={{width:"10px",height:"10px"}}/>}>
                                    <Grid container>
                                        <Grid item xs={6} sm={4} md={3}>{getDateTime(label.date)}</Grid>
                                        <Grid item xs={6} sm={4} md={3}>{label.activity}</Grid>
                                    </Grid>
                                </StepLabel>
                            </Step>
                        )
                    })}
                </Stepper>
            </Grid>

        </Grid>
    </Grid>
    )
}

export default MyPerformanceOverview;